import CustomSegment from '@/components/CustomSegment';
import PageTitle from '@/components/PageTitle';
import { useSegment } from '@/hooks/useSegment';
import DashboardLayout from '@/layouts/DashboardLayout';
import type { SegmentedType } from '@/types/global.types';
import Filters from './_components/Filters';
import OwnKPI from './_components/OwnKPI';
import TeamKPI from './_components/TeamKPI';

export type LineManagerSegmentType = 'own-kpi' | 'team-kpi';

const LineManagerKPI = () => {
  const { segment, setSegment } = useSegment<LineManagerSegmentType>(
    'line-manager-kpi',
    'own-kpi',
    false,
  );
  const SEGMENT_CONFIG: SegmentedType<LineManagerSegmentType>[] = [
    {
      value: 'own-kpi',
      label: 'Own KPI',
      view: <OwnKPI />,
    },
    {
      value: 'team-kpi',
      label: 'Team Members KPI Set-Up',
      view: <TeamKPI />,
    },
  ];
  const currentSegment = SEGMENT_CONFIG.find((s) => s.value === segment);

  return (
    <DashboardLayout title="Performance">
      <PageTitle
        classNames={{ root: 'items-start' }}
        title="Performance"
        items={[
          { title: 'Dashboard', path: '/admin/control-panel/dashboard' },
          { title: currentSegment?.label },
        ]}
      >
        <Filters type={segment} />
      </PageTitle>

      <CustomSegment
        config={SEGMENT_CONFIG}
        selected={segment}
        onChange={setSegment}
      />
      <div className="mt-5">{currentSegment?.view}</div>
    </DashboardLayout>
  );
};

export default LineManagerKPI;
